export const ticketStatusUpdateEmailBody = ({
  fullname = "User",
  ticketId,
  subject,
  oldStatus,
  newStatus,
  updatedAt,
  updatedBy,
  description = "—", // added default description
}) => `
  <p>Hello <strong>${fullname}</strong>,</p>

  <p>
    The status of your support ticket on the
    <strong>Greenwells Helpdesk Platform</strong> has been updated.
  </p>

  <table
    border="1"
    cellpadding="8"
    cellspacing="0"
    style="border-collapse: collapse; margin: 15px 0; width: 100%;"
  >
    <tr style="background-color: #f2f2f2;">
      <th align="left">Ticket ID</th>
      <td>${ticketId}</td>
    </tr>
    <tr>
      <th align="left">Subject</th>
      <td>${subject}</td>
    </tr>
    <tr>
      <th align="left">Previous Status</th>
      <td>${oldStatus}</td>
    </tr>
    <tr>
      <th align="left">Current Status</th>
      <td><strong>${newStatus}</strong></td>
    </tr>
    <tr>
      <th align="left">Updated By</th>
      <td>${updatedBy || "Support Team"}</td>
    </tr>
    <tr>
      <th align="left">Updated On</th>
      <td>${updatedAt}</td>
    </tr>

     <tr>
      <th align="left">Additional information</th>
      <td>${description}</td>
    </tr>
  </table>

  <p>
    You may log in to the helpdesk to view details, add comments, or track progress.
  </p>

  <p>
     <strong>Access the Helpdesk:</strong><br/>
    <a href="https://helpdesk.greenwellsenergies.co.ke" target="_blank">
      https://helpdesk.greenwellsenergies.co.ke
    </a>
  </p>

  <p>
    Please do not reply to this email. This is an automated notification.
  </p>

  <p>
    Regards,<br/>
    <strong>Greenwells Support Team</strong>
  </p>
`;
